"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _riskControl = require("@/api/riskControl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LittleBIndex',
  data: function data() {
    return {
      pagination: {
        total: 4
      },
      queryData: {
        phone: '',
        alipayAccount: '',
        riskStatus: undefined,
        timeRange: [],
        page: {
          page: 1,
          size: 20
        }
      },
      tableData: [],
      allData: [],
      listLoading: false,
      dialogVisible: false,
      dialogType: 'add',
      // add / edit
      dialogTitle: '新增风控名单',
      existRiskTip: false,
      currentRow: null,
      formData: {
        accountType: 1,
        account: '',
        riskReason: ''
      },
      searchResults: [],
      searchUserLoading: false,
      formRules: {
        accountType: [{
          required: true,
          message: '请选择风控账号类型',
          trigger: 'change'
        }],
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        riskReason: [{
          required: true,
          message: '请输入风控原因',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    'formData.account': function formDataAccount(val) {
      if (!val) {
        this.searchResults = [];
      }
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    onUserDetails: function onUserDetails(value) {
      console.log('value--111-', value);
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    },
    // 列表查询
    getList: function getList() {
      var _this = this;
      var _this$queryData = this.queryData,
        phone = _this$queryData.phone,
        alipayAccount = _this$queryData.alipayAccount,
        riskStatus = _this$queryData.riskStatus,
        timeRange = _this$queryData.timeRange,
        page = _this$queryData.page;
      var params = {
        page: page.page,
        size: page.size
      };
      if (phone) {
        params.phone = phone;
      }
      if (alipayAccount) {
        params.alipayAccount = alipayAccount;
      }
      if (riskStatus !== undefined && riskStatus !== null && riskStatus !== '') {
        params.riskStatus = riskStatus;
      }
      if (timeRange && timeRange.length === 2) {
        params.riskBeginTime = timeRange[0];
        params.riskEndTime = timeRange[1];
      }
      this.listLoading = true;
      (0, _riskControl.queryRiskBlacklistTenantPaged)(params).then(function (res) {
        var list = (res.data.data || []).map(function (item) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            nickname: item.memberName,
            uid: item.memberId
          });
        });
        _this.tableData = list;
        _this.allData = list;
        _this.pagination.total = res.data.total || 0;
      }).catch(function () {}).finally(function () {
        _this.listLoading = false;
      });
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.getList();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        phone: '',
        alipayAccount: '',
        riskStatus: undefined,
        timeRange: [],
        page: {
          page: 1,
          size: 20
        }
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.getList();
    },
    // 风控状态开关变化
    onRiskStatusChange: function onRiskStatusChange(row, val) {
      var _this2 = this;
      var msg = val === 1 ? '确认打开当前用户风控状态？' : '确认解除当前用户风控状态？';
      this.$confirm(msg, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log('val-- val', val);
        (0, _riskControl.updateRiskBlacklistTenant)({
          ids: row.id,
          riskStatus: val
        }).then(function () {
          _this2.$message.success('已操作成功');
          _this2.getList();
        }).catch(function () {
          row.riskStatus = 1;
        });
        // 解除风控时调用接口
        // if (val === 0) {
        //   updateRiskBlacklistTenant({ ids: [row.id] }).then(() => {
        //     this.$message.success('已解除风控')
        //     this.getList()
        //   }).catch(() => {
        //     row.riskStatus = 1
        //   })
        // } else {
        //   this.$message.success('已开启风控')
        //   this.getList()
        // }
      }).catch(function () {
        // 取消则恢复状态
        row.riskStatus = val === 1 ? 0 : 1;
      });
    },
    // 新增
    onAdd: function onAdd() {
      var _this3 = this;
      this.dialogType = 'add';
      this.dialogTitle = '新增风控名单';
      this.existRiskTip = false;
      this.currentRow = null;
      this.formData = {
        accountType: 1,
        account: '',
        riskReason: ''
      };
      this.searchResults = [];
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs.riskForm && _this3.$refs.riskForm.clearValidate();
      });
    },
    // 搜索用户
    onSearchUser: function onSearchUser() {
      var _this4 = this;
      if (!this.formData.account) {
        this.$message.warning('请输入账号');
        return;
      }
      // if (this.formData.accountType === 1) {
      //   const phoneReg = /^1[3-9]\d{9}$/
      //   if (!phoneReg.test(this.formData.account)) {
      //     this.$message.warning('请输入正确的手机号')
      //     return
      //   }
      // }
      var accountType = this.formData.accountType;
      this.searchUserLoading = true;
      (0, _riskControl.queryRiskBlacklistTenantMember)({
        accountType: accountType,
        keyword: this.formData.account
      }).then(function (res) {
        var list = res.data || [];
        if (list.length > 0) {
          _this4.searchResults = list;
        } else {
          _this4.searchResults = [];
          _this4.$message.warning('未找到匹配用户');
        }
      }).catch(function () {
        _this4.searchResults = [];
      }).finally(function () {
        _this4.searchUserLoading = false;
      });
    },
    // 弹窗确认
    onConfirm: function onConfirm() {
      var _this5 = this;
      this.$refs.riskForm.validate(function (valid) {
        if (!valid) return;
        if (_this5.dialogType === 'add' && _this5.searchResults.length === 0) {
          _this5.$message.warning('请先搜索用户');
          return;
        }
        _this5.$confirm('确认风控当前用户？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          if (_this5.dialogType === 'add') {
            var memberIdList = _this5.searchResults.map(function (item) {
              return item.memberId;
            });
            var params = {
              accountType: _this5.formData.accountType,
              account: _this5.formData.account,
              memberIdList: memberIdList,
              riskReason: _this5.formData.riskReason
            };
            (0, _riskControl.saveRiskBlacklistTenant)(params).then(function () {
              _this5.$message.success('新增风控名单成功');
              _this5.dialogVisible = false;
              _this5.queryData.page.page = 1;
              _this5.getList();
            }).catch(function () {});
          } else if (_this5.dialogType === 'edit' && _this5.currentRow) {
            var target = _this5.allData.find(function (item) {
              return item.id === _this5.currentRow.id;
            });
            if (target) {
              target.phone = _this5.formData.accountType === 'phone' ? _this5.formData.account : target.phone;
              target.alipayAccount = _this5.formData.accountType === 'alipay' ? _this5.formData.account : target.alipayAccount;
              target.riskReason = _this5.formData.riskReason;
            }
            _this5.$message.success('编辑风控信息成功');
            _this5.dialogVisible = false;
            _this5.queryData.page.page = 1;
            _this5.getList();
          }
        }).catch(function () {});
      });
    },
    // 切换账号类型
    onAccountTypeChange: function onAccountTypeChange() {
      var _this6 = this;
      this.formData.account = '';
      this.formData.riskReason = '';
      this.searchResults = [];
      this.$nextTick(function () {
        _this6.$refs.riskForm && _this6.$refs.riskForm.clearValidate();
      });
    },
    // 弹窗重置
    onReset: function onReset() {
      var _this7 = this;
      if (this.dialogType === 'edit' && this.currentRow) {
        this.setFormData(this.currentRow);
      } else {
        this.formData = {
          accountType: 1,
          account: '',
          riskReason: ''
        };
      }
      this.$nextTick(function () {
        _this7.$refs.riskForm && _this7.$refs.riskForm.clearValidate();
      });
    },
    onDialogClose: function onDialogClose() {
      this.$refs.riskForm && this.$refs.riskForm.resetFields();
    },
    setFormData: function setFormData(row) {
      var accountType = row.alipayAccount && row.alipayAccount !== '-' ? 2 : 1;
      this.formData = {
        accountType: accountType,
        account: accountType === 2 ? row.alipayAccount : row.phone,
        riskReason: row.riskReason
      };
    },
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      var h = String(date.getHours()).padStart(2, '0');
      var min = String(date.getMinutes()).padStart(2, '0');
      var s = String(date.getSeconds()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(h, ":").concat(min, ":").concat(s);
    }
  }
};